import React from 'react'

const About = ({className}) => (
  <div className={`about ${className}`} id="about">
    <h2 className="about-title">
      A <span className="hide-768">one day </span>conference<br />
      for every CSS aficionado.
    </h2>
    <p className="about-text">
      A place to unite front-end developers and designers and celebrate the language. CSSConf Argentina is a non-profit event for the people that build the web!
    </p>
    <div className="about-cta item-link item-link_arrow">
      <a href="#tickets">Buy tickets</a>
    </div>
  </div>
)

About.defaultProps = {
  className: ""
}

export default About



// WEBPACK FOOTER //
// ./src/components/About/index.js